class ComparisonSection extends HTMLElement {
  constructor() {
    super();

    // Initialize the swiper comparison__nav to be the thumb of the main swiper (mobile only)
    const navElement = this.querySelector('.comparison__nav');
    if (navElement) {
      this.swiperThumbs = new Swiper(navElement, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2,
        spaceBetween: 6,
      });
    }

    // Initialize the mobile image swiper
    const mobileImageSwiperElement = this.querySelector('.comparison__mobile-image-swiper');
    if (mobileImageSwiperElement) {
      this.mobileImageSwiper = new Swiper(mobileImageSwiperElement, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 300,
        allowTouchMove: true,
      });
    }

    // Initialize the main content swiper
    const swiperElement = this.querySelector('.comparison__swiper');
    if (swiperElement) {
      this.swiper = new Swiper(swiperElement, {
        direction: 'horizontal',
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        thumbs: {
          swiper: this.swiperThumbs || null,
        },
      });

      // Sync mobile image swiper with main swiper
      if (this.mobileImageSwiper) {
        this.swiper.on('slideChange', () => {
          this.mobileImageSwiper.slideToLoop(this.swiper.realIndex);
        });

        this.mobileImageSwiper.on('slideChange', () => {
          this.swiper.slideToLoop(this.mobileImageSwiper.realIndex);
        });
      }
    }

    // Handle navigation button clicks
    document.querySelectorAll('.comparison__nav-item').forEach((button, index) => {
      button.addEventListener('click', () => {
        // Update active state
        document.querySelectorAll('.comparison__nav-item').forEach((btn) => {
          btn.classList.remove('comparison__nav-item--active');
        });
        button.classList.add('comparison__nav-item--active');

        // Change slide on both swipers
        if (this.swiper) {
          this.swiper.slideToLoop(index);
        }
        if (this.mobileImageSwiper) {
          this.mobileImageSwiper.slideToLoop(index);
        }
      });
    });
  }
}

customElements.define('comparison-section', ComparisonSection);

// Expose class globally for dynamic initialization
window.ComparisonSection = ComparisonSection;
